import { WatchListRiskRatingTier } from '../../interfaces/client'
import { ClientIndustries } from '../../interfaces/client'
import { FilterFieldType, IFilter } from './types'

export const RISK_RATING_TABLE_FILTERS_CONFIG = [
  {
    field: 'clientName',
    dbField: 'client_name',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Client',
    alias: 'clientInfo',
  },
  {
    field: 'riskRatingTier',
    type: FilterFieldType.List,
    excludeFullSearchFilter: true,
    excludeColumn: true,
    title: 'Risk Tier',
    isMultiple: true,
    options: Object.values(WatchListRiskRatingTier).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    field: 'industry',
    type: FilterFieldType.List,
    excludeFullSearchFilter: true,
    excludeColumn: true,
    title: 'Industry',
    alias: 'clientInfo',
    isMultiple: true,
    options: Object.values(ClientIndustries).map((value) => ({
      value,
      label: value,
    })),
  },

  {
    field: 'riskRating',
    dbField: 'risk_rating',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Risk Rating',
    alias: 'riskRatingRawScore',
    placeholder: 'Risk Rating Score',
  },
  {
    field: 'riskRatingChange',
    dbField:
      'COALESCE( "riskRatingRawScore".risk_rating - "previousRiskRatingRawScore".risk_rating , 0)',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Change',
  },
  {
    field: 'lineTurn',
    dbField: 'line_turn',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Line Turn',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'cashBurn',
    dbField: 'cash_burn',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T3M',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'cashBurnT6m',
    dbField: 'cash_burn_t6m',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T6M',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'cashBurnT12m',
    dbField: 'cash_burn_t12m',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T12M',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'grossMarginRollingAvg',
    dbField: 'gross_margin_rolling_avg',
    type: FilterFieldType.Number,
    isSortable: true,
    title: '3M Gross Margin',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'percentApLess_60',
    dbField: 'percent_ap_less_60',
    type: FilterFieldType.Number,
    isSortable: true,
    title: '% AP Under 60',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'ebitda_6MonthRollingAvg',
    dbField: 'ebitda_6_month_rolling_avg',
    type: FilterFieldType.Number,
    isSortable: true,
    title: '6M EBITDA',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'currentRatio',
    dbField: 'current_ratio',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Current Ratio',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'percentArLess_60',
    dbField: 'percent_ar_less_60',
    type: FilterFieldType.Number,
    isSortable: true,
    title: '% AR Under 60',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'dilution',
    dbField: 'dilution',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Dilution',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'arTop_5Conc',
    dbField: 'ar_top_5_conc',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'AR Top 5 Conc.',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'weeksOfSupply',
    dbField: 'weeks_of_supply',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'WoS',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'yoyNetRevGrowth',
    dbField: 'yoy_net_rev_growth',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'YoY Net Revenue',
    alias: 'riskRatingRawScore',
  },
  {
    field: 'inventoryHealthRating',
    dbField: 'inventory_rating',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Inventory Rating',
    alias: 'inventoryHealth',
  },
  {
    field: 'loanBalance',
    dbField: 'COALESCE(loanBalance.loan_balance, 0) + COALESCE(termLoanBalances.loan_balance, 0)',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Loan Balance',
  },
  {
    field: 'maturityDate',
    dbField: 'maturity_date',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Maturity Date',
    alias: 'clientInfo',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'userId',
        type: FilterFieldType.Text,
      },
    ],
    quickFilters: [
      {
        title: 'My Clients',
        isHidden: true,
        filters: {
          userId: '',
        },
      },
      {
        title: 'Watchlist & Workout Tiers',
        filters: {
          riskRatingTier: [WatchListRiskRatingTier.Watchlist, WatchListRiskRatingTier.Workout],
        },
      },
    ],
  },
] as const satisfies IFilter[]

export const RISK_RATING_TABLE_VALUE_FILTERS_CONFIG = [
  {
    field: 'clientName',
    dbField: 'client_name',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Client',
    alias: 'clientInfo',
  },
  {
    field: 'riskRatingTier',
    type: FilterFieldType.List,
    isMultiple: true,
    excludeFullSearchFilter: true,
    excludeColumn: true,
    title: 'Risk Tier',
    options: Object.values(WatchListRiskRatingTier).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    field: 'industry',
    type: FilterFieldType.List,
    alias: 'clientInfo',
    excludeFullSearchFilter: true,
    excludeColumn: true,
    title: 'Industry',
    isMultiple: true,
    options: Object.values(ClientIndustries).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    field: 'riskRating',
    dbField: 'risk_rating',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Risk Rating',
    alias: 'riskRatingRawScore',
    placeholder: 'Risk Rating Score',
  },
  {
    field: 'lineTurn',
    dbField: 'line_turn',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Line Turn',
    alias: 'riskRatingRawData',
    isMultiple: true,
  },
  {
    field: 'cashBurn',
    dbField: 'cash_burn',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T3M',
    alias: 'riskRatingRawData',
  },
  {
    field: 'cashBurnT6m',
    dbField: 'cash_burn_t6m',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T6M',
    alias: 'riskRatingRawData',
  },
  {
    field: 'cashBurnT12m',
    dbField: 'cash_burn_t12m',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Cash Burn T12M',
    alias: 'riskRatingRawData',
  },
  {
    field: 'grossMarginRollingAvg',
    dbField: 'gross_margin_rolling_avg',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: '3M Gross Margin',
    alias: 'riskRatingRawData',
  },
  {
    field: 'percentApLess_60',
    dbField: 'percent_ap_less_60',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: '% AP Under 60',
    alias: 'riskRatingRawData',
  },
  {
    field: 'ebitda_6MonthRollingAvg',
    dbField: 'ebitda_6_month_rolling_avg',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: '6M EBITDA',
    alias: 'riskRatingRawData',
  },
  {
    field: 'currentRatio',
    dbField: 'current_ratio',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Current Ratio',
    alias: 'riskRatingRawData',
  },
  {
    field: 'percentArLess_60',
    dbField: 'percent_ar_less_60',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: '% AR Under 60',
    alias: 'riskRatingRawData',
  },
  {
    field: 'dilution',
    dbField: 'dilution',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: 'Dilution',
    alias: 'riskRatingRawData',
  },
  {
    field: 'arTop_5Conc',
    dbField: 'ar_top_5_conc',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: 'AR Top 5 Conc.',
    alias: 'riskRatingRawData',
  },
  {
    field: 'weeksOfSupply',
    dbField: 'weeks_of_supply',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'WoS',
    alias: 'riskRatingRawData',
  },
  {
    field: 'yoyNetRevGrowth',
    dbField: 'yoy_net_rev_growth',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: 'YoY Net Revenue',
    alias: 'riskRatingRawData',
  },
  {
    field: 'loanBalance',
    dbField: 'COALESCE(loanBalance.loan_balance, 0) + COALESCE(termLoanBalances.loan_balance, 0)',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Loan Balance',
  },
  {
    field: 'maturityDate',
    dbField: 'maturity_date',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Maturity Date',
    alias: 'clientInfo',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'userId',
        type: FilterFieldType.Text,
      },
    ],
    quickFilters: [
      {
        title: 'My Clients',
        isHidden: true,
        filters: {
          userId: '',
        },
      },
      {
        title: 'Watchlist & Workout Tiers',
        filters: {
          riskRatingTier: [WatchListRiskRatingTier.Watchlist, WatchListRiskRatingTier.Workout],
        },
      },
    ],
  },
] as const satisfies IFilter[]
